module.exports = __webpack_public_path__ + "static/media/startpage.176b9868.jpg";